import request from "../utils/request";

export async function createNewTransfer(newTransfer) {
  return request.post("StockTransfer/Create", {
    entries: newTransfer
  });
}

export async function commitLatedTransfer(stockTransferId) {
  return request.post("StockTransfer/CommitLatedTransfer?stockTransferId=" + stockTransferId);
}

export async function getStockTransferList(payload) {
  return request.get("MonthlyStockTransfer/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      stockId: payload.stock ? payload.stock.id : null,
      minPreMonthTransfer: payload.rangePreTransfer ? payload.rangePreTransfer.min : null,
      maxPreMonthTransfer: payload.rangePreTransfer ? payload.rangePreTransfer.max : null,
      minCurrMonthSaved: payload.rangeCurrSaved ? payload.rangeCurrSaved.min : null,
      maxCurrMonthSaved: payload.rangeCurrSaved ? payload.rangeCurrSaved.max : null,
      minCurrMonthConsume: payload.rangeCurrConsume ? payload.rangeCurrConsume.min : null,
      maxCurrMonthConsume: payload.rangeCurrConsume ? payload.rangeCurrConsume.max : null,
      minCurrMonthLeft: payload.rangeCurrLeft ? payload.rangeCurrLeft.min : null,
      maxCurrMonthLeft: payload.rangeCurrLeft ? payload.rangeCurrLeft.max : null,
      minResult: payload.rangeNumber ? payload.rangeNumber.min : null,
      maxResult: payload.rangeNumber ? payload.rangeNumber.max : null,
      branchId: payload.branch != null && payload.branch != undefined && payload.branch.id > 0 ? payload.branch.id : null,
      month: payload.month != null ? payload.month.id : null,
      year: payload.year != null ? payload.year : null
    }
  });
}

export async function getStockTransferExcel(transferId, tableOptions) {
  return request.get("StockTransfer/GetStockTransferExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      transferId: transferId,
      sortBy: tableOptions.sortBy,
      sortDirection: tableOptions.sortDirection,
      pageIndex: tableOptions.pageIndex,
      pageSize: tableOptions.pageSize,
      stockId: tableOptions.stock ? tableOptions.stock.id : null,
    }
  });
}

export async function getTransferListExcel(payload) {
  return request.get("StockTransfer/ListExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function getTransferListExcelForDealer(payload) {
  return request.get("StockTransfer/ListExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function getTransferList(payload) {
  return request.get("StockTransfer/List", {
    params: {
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      transferMonth: payload.month ? payload.month.id : null,
      transferYear: payload.year
    }
  });
}

export async function getTransferListForDealer(payload) {
  return request.get("StockTransfer/ListForDealer", {
    params: {
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      transferMonth: payload.month ? payload.month.id : null,
      transferYear: payload.year
    }
  });
}

getEmptyStocksExcel
export async function getEmptyStocksExcel(payload) {
  return request.get("StockTransfer/GetEmptyStocksExcel",
    {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      }
    });
}

export async function getTransferEntriesMonthly(payload) {
  return request.get("StockTransfer/GetTransferEntriesMonthly", {
    params: {
      month: payload.month != null ? payload.month.id : null,
      year: payload.year != null ? payload.year : null,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      stockId: payload.stock ? tableOptions.stock.id : null
    }
  })
}

export async function getBranchTransfers(payload) {
  return request.get("StockTransfer/BranchTransfers", {
    params: {
      transferMonth: payload.month != null ? payload.month.id : null,
      transferYear: payload.year != null ? payload.year : null,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function getBranchTransfersForDealer(payload) {
  return request.get("StockTransfer/BranchTransfersForDealer", {
    params: {
      transferMonth: payload.month != null ? payload.month.id : null,
      transferYear: payload.year != null ? payload.year : null,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function getBranchTransfersExcel(payload) {
  return request.get("StockTransfer/GetBranchTransfersExcel",
    {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      },
      params: {
        transferMonth: payload.month != null ? payload.month.id : null,
        transferYear: payload.year != null ? payload.year : null,
        branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
        startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
        startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
        endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
        endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      }
    });
}

export async function getBranchTransfersExcelForDealer(payload) {
  return request.get("StockTransfer/GetBranchTransfersExcelForDealer",
    {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      },
      params: {
        transferMonth: payload.month != null ? payload.month.id : null,
        transferYear: payload.year != null ? payload.year : null,
        branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
        startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
        startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
        endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
        endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      }
    });
}

export async function getStockTransfer(transferId, tableOptions) {
  return request.get("StockTransfer/StockTransfer", {
    params: {
      transferId: transferId,
      sortBy: tableOptions.sortBy,
      sortDirection: tableOptions.sortDirection,
      pageIndex: tableOptions.pageIndex,
      pageSize: tableOptions.pageSize,
      stockId: tableOptions.stock ? tableOptions.stock.id : null,
    }
  });
}

export async function getStockHistoryExcel(payload, stockId) {
  if(!stockId) return;
  return request.get("StockTransfer/GetEntryHistoryExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      stockId: stockId,
      minPreMonthTransfer: payload.rangePreTransfer ? payload.rangePreTransfer.min : null,
      maxPreMonthTransfer: payload.rangePreTransfer ? payload.rangePreTransfer.max : null,
      minCurrMonthSaved: payload.rangeCurrSaved ? payload.rangeCurrSaved.min : null,
      maxCurrMonthSaved: payload.rangeCurrSaved ? payload.rangeCurrSaved.max : null,
      minCurrMonthConsume: payload.rangeCurrConsume ? payload.rangeCurrConsume.min : null,
      maxCurrMonthConsume: payload.rangeCurrConsume ? payload.rangeCurrConsume.max : null,
      minCurrMonthLeft: payload.rangeCurrLeft ? payload.rangeCurrLeft.min : null,
      maxCurrMonthLeft: payload.rangeCurrLeft ? payload.rangeCurrLeft.max : null,
      minResult: payload.rangeNumber ? payload.rangeNumber.min : null,
      maxResult: payload.rangeNumber ? payload.rangeNumber.max : null
    }
  });
}

export async function getStockTransferHistory(payload, stockId) {
  if(!stockId) return;
  return request.get("StockTransfer/GetStockTransferHistory", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      stockId: stockId,
      minPreMonthTransfer: payload.rangePreTransfer ? payload.rangePreTransfer.min : null,
      maxPreMonthTransfer: payload.rangePreTransfer ? payload.rangePreTransfer.max : null,
      minCurrMonthSaved: payload.rangeCurrSaved ? payload.rangeCurrSaved.min : null,
      maxCurrMonthSaved: payload.rangeCurrSaved ? payload.rangeCurrSaved.max : null,
      minCurrMonthConsume: payload.rangeCurrConsume ? payload.rangeCurrConsume.min : null,
      maxCurrMonthConsume: payload.rangeCurrConsume ? payload.rangeCurrConsume.max : null,
      minCurrMonthLeft: payload.rangeCurrLeft ? payload.rangeCurrLeft.min : null,
      maxCurrMonthLeft: payload.rangeCurrLeft ? payload.rangeCurrLeft.max : null,
      minResult: payload.rangeNumber ? payload.rangeNumber.min : null,
      maxResult: payload.rangeNumber ? payload.rangeNumber.max : null
    }
  });
}

export async function getTransferForCreate() {
  return request.get("StockTransfer/GetTransferForCreate");
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
